/** 签名证书的拒绝说明（planning P4-3b D-583、D-589、D-593）：真正的中文译文，不是英文副本。 */
export default {
  not_home_tenant: '签名证书只能由本市政局的人员管理和使用。',
  signing_certificate_not_found: '找不到该签名证书。请重新加载列表。',
  signing_certificate_not_yours: '该个人证书属于他人。只有证书上署名的人才能用它签名。',
  signing_certificate_unusable: '该证书现在不能签名。',
  signing_key_unreadable: '无法打开该证书的私钥。本系统的加密密钥可能已更改。请重新签发或上传该证书。',
  signing_failed: 'gisify 无法用此证书签署该函件。',
  actor_not_permitted: '您无权对签名证书执行此操作。',
  invalid_signing_certificate_request: '该请求无效。请检查每个字段后重试。',
  signing_file_too_large: '文件过大。PKCS#12 文件或证书链最多 64 KiB，密钥最多 16 KiB。',
  subject_has_ic_number:
    '此证书的某个名称中有看似身份证号码的内容，而证书不得包含身份证号码。请检查您输入的名称，以及信头上的市政局名称。',
  bound_identity_not_found: '此人不是本市政局的在用用户。',
  letterhead_council_missing: '请先在信头上填写市政局名称。根证书的机构名称取自该名称。',
  letterhead_council_too_long:
    '信头上的市政局名称超过 64 个字符，这是证书允许的上限。请先在信头上缩短名称；名称绝不会被截断。',
  letterhead_council_unwritable:
    '信头上的市政局名称含有证书无法容纳的控制字符。请先在信头上重新输入该名称；gisify 绝不会替您修改。',
  signing_root_exists: '本市政局已有根证书。请先删除它，再创建新的根证书。',
  signing_root_missing: '请先创建市政局根证书，并等待其就绪。',
  signing_certificates_full: '签名证书数量已达上限。请删除一个不再使用的证书。',
  import_rate_limited: '您在过去一小时内已上传 10 个证书（包括已删除的），已达上限。请稍后再试。',
  signing_certificate_state: '现在不能对此证书执行该操作。正在准备中的证书不能删除；请等到它就绪或被拒绝。',
  signing_certificate_name_unclear: '此证书不能批准：它没有恰好一个可供 gisify 与签署人比较的名称。',
  pfx_unreadable: '无法读取该 PKCS#12 文件。',
  pfx_password_wrong: '该密码无法打开此文件。',
  pfx_no_integrity: '该 PKCS#12 文件没有密码校验，gisify 无法确认文件完整。请用密码重新导出。',
  pem_password_wrong: '该密码无法打开此密钥。',
  key_certificate_mismatch: '该密钥与文件中的证书不匹配。',
  certificate_expired: '该证书已过期。',
  chain_too_long: '文件中的证书太多。请上传证书链较短的证书。',
  chain_too_large: '证书及其证书链太大，无法放入签名中。请上传证书链较短的证书。',
  signing_certificate_duplicate: '此证书已在 gisify 中。请使用该证书，或先将其删除。',
  job_timeout: '准备证书耗时过长，已被停止。请重试。',
  dispatch_failed: '无法开始准备证书。请重试。',
  pfx_cipher_unsupported: '该 PKCS#12 文件使用了 gisify 不接受的保护方式。',
  pem_unreadable: '无法读取该 PEM 文件。',
  key_missing: '文件中没有私钥。',
  key_more_than_one: '文件中有多个私钥。请上传恰好只有一个私钥的文件。',
  key_algorithm: '不接受这种类型或长度的密钥。请使用 2048 至 8192 位的 RSA，或 P-256、P-384、P-521 上的 ECDSA。',
  certificate_usage: '该证书并非用于签署文件。',
  certificate_extension: '该证书带有 gisify 无法检查的扩展项。',
  certificate_encoding: '文件中有证书未按标准方式编码。',
  signing_root_inactive: '市政局根证书尚未就绪，因此不能在其下签发证书。',
  signing_root_unreadable: '无法打开市政局根证书的密钥。本系统的加密密钥可能已更改。请删除根证书并创建新的根证书。',
  generate_failed: 'gisify 无法生成该证书。',
  details: {
    signing_certificate_unusable: {
      disabled: '它已被停用。',
      deleted: '它已被删除。',
      expired: '它已过期。',
      not_yet_valid: '它尚未生效。',
      root_inactive: '签发它的市政局根证书尚未就绪。',
    },
    signing_failed: {
      key_mismatch: '保存的密钥与该证书不匹配。',
      sign_error: '签名因错误而中止。请重试；如再次发生，请告知管理员。',
      certificate_changed: '签名中的证书与所选的证书不同。',
      too_large: '证书及其证书链太大，无法放入签名中。',
    },
    pfx_unreadable: {
      ber: '其结构已损坏或不完整。',
      shape: '其中有 gisify 不读取的部分。',
      too_complex: '它太大或嵌套太深。',
      iterations: '其密码的迭代次数超过 gisify 允许的上限。',
    },
    pfx_cipher_unsupported: {
      rc2_40: '它使用 40 位 RC2。请用 AES-256-CBC（OpenSSL 3 的默认方式）重新导出。',
      rc2_128: '它使用 128 位 RC2。请用 AES-256-CBC 重新导出。',
      rc4_128: '它使用 128 位 RC4。请用 AES-256-CBC 重新导出。',
      rc4_40: '它使用 40 位 RC4。请用 AES-256-CBC 重新导出。',
      des2: '它使用双密钥三重 DES。请用 AES-256-CBC 重新导出。',
      pbes1: '它使用旧的 PBES1 方式。请用 AES-256-CBC 重新导出。',
      pbes2_cipher: '其加密算法不是 AES-CBC；AES-GCM 同样不被接受。请用 AES-256-CBC 重新导出。',
      pbmac1: '其密码校验方式为 PBMAC1。请改用 HMAC-SHA-256 校验重新导出。',
      enveloped: '它是锁定到某个证书，而不是用密码保护。请用密码重新导出。',
      unknown: 'gisify 不认识其保护方式。请用 AES-256-CBC 重新导出。',
    },
    pem_unreadable: {
      armour: '其 BEGIN 和 END 行缺失或损坏。',
      legacy_encryption: '该密钥使用旧的 OpenSSL 加密方式。请用 openssl pkcs8 -topk8 转换为 PKCS#8。',
      not_a_key: '密钥块中没有私钥。',
      two_keys: '其中有多个密钥。',
      no_certificate: '证书链文件中没有证书。',
    },
    key_algorithm: {
      rsa_small: '该 RSA 密钥短于 2048 位。',
      rsa_large: '该 RSA 密钥长于 8192 位。',
      curve: '其椭圆曲线不是 P-256、P-384 或 P-521。',
      rsa_pss: '该密钥只能用于 RSA-PSS。',
      ed25519: '该密钥是 Ed25519。',
      other: '该密钥属于其他类型，或其参数不被接受。',
    },
    certificate_usage: {
      is_ca: '它是 CA 证书，不能用于签署函件。',
      key_usage: '其密钥用途不允许数字签名。',
      extended_key_usage: '其扩展密钥用途不允许签署文件。',
    },
    certificate_extension: {
      duplicate: '它重复了某个扩展项。',
      critical_unknown: '它有 gisify 不认识的关键扩展项。',
      constraints: '它带有 gisify 不执行的名称或策略约束。',
    },
    certificate_encoding: {
      leaf: '证书本身不是严格的 DER 编码。',
      chain: '证书链中有证书不是严格的 DER 编码。',
    },
    generate_failed: {
      internal: 'gisify 内部出错。请重试；如再次发生，请告知管理员。',
    },
  },
}
